import { useQuery } from 'react-query';
import { useServices } from '../../../services/useServices';
import { IConfigResponse } from '../book.dto';

const useConfig = () => {
  const {
    book: { getConfig }
  } = useServices();

  const res = useQuery<IConfigResponse, Error>(
    ['config'],
    () => getConfig(),
    {
      refetchInterval: false,
      staleTime: Infinity,
      cacheTime: Infinity
    }
  );

  return {
    data: res.data,
    isLoading: res.isLoading,
    isError: res.isError,
    error: res.error
  };
};

export default useConfig;